// extracted by mini-css-extract-plugin
export default {"container":"termosuso_container__dBXpR","content":"termosuso_content__zwcDI"};